// getters
const inventoryProviders = state => state.inventoryProviders

export default {
  inventoryProviders
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/providers/getters.js